export default {
  VISITORS_SET_STATE: '@visitors/VISITORS_SET_STATE',
  VISITORS_DATA_REQUEST: '@visitors/VISITORS_DATA_REQUEST',
};
